module.exports = __webpack_public_path__ + "static/media/splash.2997ee73.mp4";